import { useMutation } from '@connectrpc/connect-query'
import { withdrawBiddingBlockBidGroups } from '@ebalance/proto/bffuser/v1/bidding_block_service-BiddingBlockService_connectquery'

import { useWorkflowCaseScopedMutation } from '~/hooks/bidding/useWorkflowCaseScopedMutation'
import type { InvalidatingMutationResultFor } from '~/hooks/useInvalidatingMutation'

/**
 * 入札中のブロック入札グループの一括取下 mutation hook (AC-BSP-116)。 対象はグループ (id) で、
 * 楽観ロックの基準はグループの updated_at。 通常入札の `useWithdrawBiddingSpotBids` と同じ理由で
 * invalidate を持たない。
 */
export const useWithdrawBiddingBlockBidGroups =
  (): InvalidatingMutationResultFor<typeof withdrawBiddingBlockBidGroups> =>
    useWorkflowCaseScopedMutation(useMutation(withdrawBiddingBlockBidGroups))
